import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

export default function CTASection() {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, { once: true, margin: '-80px' });

  return (
    <section className="relative py-24 md:py-32 lg:py-40 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20premium%20barbershop%20interior%20at%20golden%20hour%2C%20warm%20ambient%20lighting%2C%20leather%20barber%20chairs%2C%20dark%20wood%20and%20brass%20details%2C%20masculine%20luxury%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20charcoal%20and%20amber%20tones%2C%20cinematic%20photography&width=1920&height=900&seq=cta-bg-01&orientation=landscape"
          alt="Tal Pai, Tal Filho Barbearia - Agende seu horário"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-dark-950/80"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-dark-950 via-dark-950/60 to-dark-950/40"></div>

      <div ref={ref} className="relative max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 text-center">
        <motion.span
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-premium-400 text-xs tracking-[0.3em] uppercase font-medium"
        >
          Pronto para a melhor experiência?
        </motion.span>

        <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mt-4 mb-4 max-w-3xl mx-auto leading-tight">
          Seu próximo corte{' '}
          <span className="text-gradient-gold">começa aqui.</span>
        </h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.2 }}
          className="text-white/50 text-base md:text-lg max-w-xl mx-auto mb-10"
        >
          Agende agora e descubra por que somos referência em barbearia premium em Fortaleza.
        </motion.p>

        <motion.a
          href="https://wa.me/5585999999999?text=Ol%C3%A1!%20Gostaria%20de%20agendar%20um%20hor%C3%A1rio."
          target="_blank"
          rel="noopener noreferrer"
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.4 }}
          className="group relative inline-flex items-center gap-3 px-10 py-4 rounded-md bg-premium-600 hover:bg-premium-500 text-white font-medium tracking-wide text-base transition-all duration-500 overflow-hidden whitespace-nowrap hover:scale-[1.02]"
        >
          <span className="relative z-10">Agendar pelo WhatsApp</span>
          <i className="ri-whatsapp-line text-xl relative z-10"></i>
          <div className="absolute inset-0 bg-gradient-to-r from-premium-500 via-premium-400 to-premium-500 bg-[length:200%_100%] animate-shimmer opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
          <div className="absolute -inset-1 rounded-lg bg-premium-500/20 blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
        </motion.a>
      </div>
    </section>
  );
}